var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('gl-badge',{attrs:{"icon":"status_failed","variant":"danger","href":_vm.failedPath}},[_vm._v("\n  "+_vm._s(_vm.n__('%d failed security job', '%d failed security jobs', _vm.failedCount))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }